import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { colors, fontSizes, fontWeights, radius, shadows, spacing } from '../theme';
import type { Testimonial } from '../data/shopData';

interface TestimonialCardProps {
  testimonial: Testimonial;
}

function StarRating({ rating }: { rating: number }) {
  return (
    <View style={styles.stars}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Text key={i} style={[styles.star, i < rating ? styles.starFilled : styles.starEmpty]}>
          ★
        </Text>
      ))}
    </View>
  );
}

export function TestimonialCard({ testimonial }: TestimonialCardProps) {
  return (
    <View style={styles.card}>
      <StarRating rating={testimonial.rating} />
      <Text style={styles.quote}>"{testimonial.quote}"</Text>
      <View style={styles.footer}>
        <View style={styles.avatar}>
          <Text style={styles.avatarText}>{testimonial.name[0]}</Text>
        </View>
        <View style={styles.authorInfo}>
          <Text style={styles.name}>{testimonial.name}</Text>
          <Text style={styles.car}>{testimonial.car} · {testimonial.date}</Text>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: colors.surface,
    borderRadius: radius.lg,
    padding: spacing.lg,
    width: 300,
    marginRight: spacing.md,
    ...shadows.card,
    borderWidth: 1,
    borderColor: colors.border,
  },
  stars: {
    flexDirection: 'row',
    marginBottom: spacing.sm,
  },
  star: {
    fontSize: 16,
    marginRight: 2,
  },
  starFilled: {
    color: '#F59E0B',
  },
  starEmpty: {
    color: colors.border,
  },
  quote: {
    fontSize: fontSizes.base,
    color: colors.textPrimary,
    lineHeight: 22,
    fontStyle: 'italic',
    flex: 1,
    marginBottom: spacing.md,
  },
  footer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  avatar: {
    width: 36,
    height: 36,
    borderRadius: radius.pill,
    backgroundColor: colors.accentLight,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: spacing.sm,
  },
  avatarText: {
    fontSize: fontSizes.base,
    fontWeight: fontWeights.semibold,
    color: colors.accent,
  },
  authorInfo: {
    flex: 1,
  },
  name: {
    fontSize: fontSizes.sm,
    fontWeight: fontWeights.semibold,
    color: colors.textPrimary,
  },
  car: {
    fontSize: fontSizes.xs,
    color: colors.textSecondary,
    marginTop: 1,
  },
});
